import { createSlice } from "@reduxjs/toolkit";

// createing reducer with intial value
export const ordersReducer = createSlice({
  name: "orders_store",
  initialState: {
    isAuthenticated: false,
    switchWarehouseView: false,
    on_holded_sales: [],
    warehouse: {
      sales_reciept: "",
      cart: [],
      products: [],
      customers: [],
      brands: [],
    },
  },
  reducers: {
    ordersAction: (state, action) => {
      state.warehouse.products = action.payload.itemsPayload;
      state.isAuthenticated = true;
    },
    switchView: (state, action) => {
      state.switchWarehouseView = action.payload;
    },
    addtoCart: (state, action) => {
      if (!state.warehouse) state.warehouse = { cart: [], products: [] };
      if (!state.warehouse.cart) state.warehouse.cart = [];
      state.warehouse.cart.unshift(action.payload.intoCart);
      state.warehouse.sales_reciept = action.payload.recieptNo;
    },
    onHoldPayload: (state, action) => {
      const prospondData = action.payload;
      if (!state.on_holded_sales) state.on_holded_sales = [];
      state.on_holded_sales.unshift(prospondData);
    },
    updateSwitchPackage: (state, action) => {
      const { index, pkg } = action.payload;

      if (!state.warehouse) state.warehouse = { cart: [], products: [] };
      if (!state.warehouse.cart) state.warehouse.cart = [];

      if (state.warehouse.cart[index]) {
        state.warehouse.cart[index].orderedQuantity = pkg;
      }
    },
    updateQuantity: (state, action) => {
      const { index, qty } = action.payload;

      if (!state.warehouse) state.warehouse = { cart: [], products: [] };
      if (!state.warehouse.cart) state.warehouse.cart = [];

      if (state.warehouse.cart) {
        state.warehouse.cart[index].orderedQuantity = qty;
      }
    },
    insertQuantity: (state, action) => {
      const { index, qty } = action.payload;

      if (!state.warehouse) state.warehouse = { cart: [], products: [] };
      if (!state.warehouse.cart) state.warehouse.cart = [];

      if (state.warehouse.cart) {
        state.warehouse.cart[index].orderedQuantity = qty;
      }
    },

    removeFromCart: (state, action) => {
      const index = action.payload;

      if (
        state.warehouse &&
        Array.isArray(state.warehouse.cart) &&
        index >= 0
      ) {
        state.warehouse.cart.splice(index, 1);
      }
    },
    deleteOnholdDispatch: (state, action) => {
      const index = action.payload;

      if (
        state.on_holded_sales &&
        Array.isArray(state.on_holded_sales) &&
        index >= 0
      ) {
        state.on_holded_sales.splice(index, 1);
      }
    },
    clearCartAction: (state) => {
      state.warehouse.cart = [];
    },
    clearProductsAction: (state) => {
      state.warehouse.products = [];
    },
    dispatchCloseRegister: (state) => {
      state.isAuthenticated = false;
      state.warehouse.cart = [];
      state.on_holded_sales = [];
      state.warehouse.products = [];
      state.warehouse.products = [];
      state.warehouse.products = [];
      state.switchWarehouseView = false;
    },
    attandOnhold: (state, action) => {
      const { buyings } = action.payload;
      if (!state.warehouse) state.warehouse = { cart: [], products: [] };
      if (!state.warehouse.cart) state.warehouse.cart = [];
      state.warehouse.cart = buyings;
    },
    // FUNCTIONALS
    onchangePurchaseItemsField: (state, action) => {
      const { index, field, value } = action.payload;

      const item = state.warehouse?.cart?.[index];

      if (!item) return;

      // Fields inside pricing
      if (
        field === "costPrice" ||
        field === "taxRate" ||
        field === "discount" ||
        field === "subTotal"
      ) {
        if (!item.pricing) {
          item.pricing = {};
        }

        item.pricing[field] = value;

        return;
      }

      // Fields directly inside cart item
      item[field] = value;
    },
  },
});

export const {
  ordersAction,
  switchView,
  addtoCart,
  updateSwitchPackage,
  updateQuantity,
  removeFromCart,
  clearCartAction,
  clearProductsAction,
  insertQuantity,
  onHoldPayload,
  attandOnhold,
  deleteOnholdDispatch,
  dispatchCloseRegister,
  onchangePurchaseItemsField,
} = ordersReducer.actions;

export default ordersReducer.reducer;
